import { promiseAction } from 'utils/store';

export const CHATS_ACTION_TYPES = {
  LOAD_CHAT_MAILINGS: 'chats/LOAD_CHAT_MAILINGS',
  CREATE_CHAT_MAILING: 'chats/CREATE_CHAT_MAILING',
  EDIT_CHAT_MAILING: 'chats/EDIT_CHAT_MAILING',
  SUBMIT_CHAT_MAILING: 'chats/SUBMIT_CHAT_MAILING',
  DELETE_CHAT_MAILING: 'chats/DELETE_CHAT_MAILING',
  LOAD_SYSTEM_USER: 'chats/LOAD_SYSTEM_USER',
};

export const loadChatMailings = promiseAction(CHATS_ACTION_TYPES.LOAD_CHAT_MAILINGS);
export const createChatMailing = promiseAction(CHATS_ACTION_TYPES.CREATE_CHAT_MAILING);
export const editChatMailing = promiseAction(CHATS_ACTION_TYPES.EDIT_CHAT_MAILING);
export const submitChatMailing = promiseAction(CHATS_ACTION_TYPES.SUBMIT_CHAT_MAILING);
export const deleteChatMailing = promiseAction(CHATS_ACTION_TYPES.DELETE_CHAT_MAILING);
export const loadSystemUser = promiseAction(CHATS_ACTION_TYPES.LOAD_SYSTEM_USER);
